import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PageWithTitle from '../../components/atom/PageWithTitle';
import ManualRefundsTable from './components/ManualRefundsTable';
import { Checkbox, FormControlLabel, Stack } from '@mui/material';
import SearchInput from '../../components/atom/SearchInput';

function ManualRefundsPage() {
    const { t } = useTranslation();
    const [filters, setFilters] = useState({
        finished: '',
        search: '',
        page: 0,
        pageSize: 10,
        sort: 'createdAt',
        sortDir: 'DESC',
    });

    return (
        <PageWithTitle
            title={t('manualrefunds.title')}
            stackHeadline
            headline={[
                <Stack
                    key="search-and-buttons"
                    direction={{ xs: 'column', md: 'row' }}
                    spacing={2}
                    alignItems={{ xs: 'stretch', md: 'center' }}
                    justifyContent="flex-end"
                    sx={{ width: '100%' }}
                >
                    <SearchInput
                        search={filters.search}
                        setSearch={(search) => setFilters({ ...filters, search, page: 0 })}
                    />
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1, sm: 2 }}>
                        <FormControlLabel
                            label={t('transactions.showOnlyUnfinished')}
                            control={
                                <Checkbox
                                    size="small"
                                    checked={filters.finished === 'false'}
                                    onChange={(ev) =>
                                        setFilters({
                                            ...filters,
                                            finished: ev.target.checked ? 'false' : '',
                                            page: 0,
                                        })
                                    }
                                    label={t('transactions.showOnlyUnfinished')}
                                />
                            }
                        />
                        <FormControlLabel
                            label={t('transactions.showOnlyFinished')}
                            control={
                                <Checkbox
                                    size="small"
                                    checked={filters.finished === 'true'}
                                    onChange={(ev) =>
                                        setFilters({
                                            ...filters,
                                            finished: ev.target.checked ? 'true' : '',
                                            page: 0,
                                        })
                                    }
                                    label={t('transactions.showOnlyFinished')}
                                />
                            }
                        />
                    </Stack>
                </Stack>,
            ]}
        >
            <ManualRefundsTable filters={filters} onFiltersChange={setFilters} />
        </PageWithTitle>
    );
}

export default ManualRefundsPage;
